import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss'],
    standalone: false
})
export class StatisticsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
